export default __webpack_public_path__ + "static/media/summary-arrow.599717ce.svg";